/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';

const BASE_URL =
	'https://dpjye2wk9gi5z.cloudfront.net/wcsstore/ExtendedSitesCatalogAssetStore/images/catalog/default';

export const NO_IMAGE_IMG = '/images/noImage.png';
export const PLACEHOLDER_IMG = '/images/placeholderImg.png';

const getLastPartOfUrl = (url: string) => url?.split('/')?.pop() || '';

export const getFullImageWithBaseUrl = (url: string) => `${BASE_URL}/${getLastPartOfUrl(url)}`;

interface ProductImgProps {
	fullImageRaw: string;
	render: (src: string) => JSX.Element;
}

export const RenderProductImg: React.FC<ProductImgProps> = ({ fullImageRaw, render }) => {
	const [imageSrc, setImageSrc] = useState(PLACEHOLDER_IMG);

	useEffect(() => {
		const _src = fullImageRaw?.includes('https://')
			? fullImageRaw
			: getFullImageWithBaseUrl(fullImageRaw);

		if (_src.includes('.mp4')) {
			setImageSrc(_src);
			return;
		}

		const img = new Image();
		img.onload = () => setImageSrc(_src);
		img.onerror = () => setImageSrc(NO_IMAGE_IMG);
		img.src = _src;
	}, [fullImageRaw]);

	return render(imageSrc);
};

export const renderImages: (
	fullImageRaws: { imageSrc: string; name?: string }[]
) => Promise<{ src: string; name?: string; status: 'loaded' | 'error' }[]> = (fullImageRaws) => {
	const promises = fullImageRaws.map((fullImageRaw) => {
		const _src = getFullImageWithBaseUrl(fullImageRaw.imageSrc);

		return new Promise<{ src: string; name?: string; status: 'loaded' | 'error' }>((resolve) => {
			const img = new Image();
			img.onload = () => resolve({ src: _src, name: fullImageRaw.name, status: 'loaded' });
			img.onerror = () => resolve({ src: _src, name: fullImageRaw.name, status: 'error' });
			img.src = _src;
		});
	});

	return Promise.all(promises);
};

export const useRenderImages = (imagesToRender: { imageSrc: string; name?: string }[]) => {
	const [imageUrls, setImageUrls] = useState<{ src: string; name?: string }[]>([]);

	useEffect(() => {
		const fetchImages = async () => {
			const results = await renderImages(imagesToRender);

			const loadedImages = results
				.filter((image) => image.status === 'loaded')
				.map(({ src, name }) => ({ src, name }));

			setImageUrls(
				loadedImages.length !== 0 ? loadedImages : [{ src: NO_IMAGE_IMG, name: 'placeholer image' }]
			);
		};

		if (imagesToRender.length > 0) {
			fetchImages();
		}
	}, [imagesToRender.length]);

	return imageUrls;
};
